document.body.addEventListener("click", (event) => {
  const header = event.target.closest(".collapsible, .custom-collapsible");
  if (!header) return;

  const container = header.closest(".collapsible-container") || header.parentElement;
  const content = container?.querySelector(".content") || header.nextElementSibling;
  if (!content || !content.classList.contains("content")) return;

  header.classList.toggle("active");
  content.classList.toggle("is-open");

  const isOpen = content.classList.contains("is-open");
  header.setAttribute("aria-expanded", isOpen);
  content.setAttribute("aria-hidden", !isOpen);
});